// extracted by mini-css-extract-plugin
export default {"header":"couponDetail_header__tgNj2"};